let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kXLbg")).then(() => parcelRequire('8RLZw'));